// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__1ioOS","mobile":"alert_mobile__128a0"};